"use client";

import React, { ReactNode, useState } from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";

interface CarouselProps {
  children: ReactNode;
  origin?: "center" | "auto" | undefined;
  perView?: number;
  inactiveScale?: number;
}

export function Carousel({
  children,
  origin,
  perView = 1,
  inactiveScale = 1,
}: CarouselProps) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(inactiveScale === 1); // ← ya cargado si no hay scale

  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    slides: {
      origin,
      perView,
    },
    created() {
      if (inactiveScale !== 1) {
        setLoaded(true);
      }
    },
  });

  return (
    <div className="w-full">
      <div
        ref={sliderRef}
        className="keen-slider"
        style={{
          visibility: loaded ? "visible" : "hidden",
        }}
      >
        {React.Children.map(children, (child, i) => (
          <div key={i} className="keen-slider__slide flex justify-center">
            <div style={{ scale: currentSlide === i ? 1 : inactiveScale }}>
              {child}
            </div>
          </div>
        ))}
      </div>

      <div className="pt-2 flex justify-center gap-2">
        {React.Children.count(children) > 1 &&
          Array.from({ length: React.Children.count(children) }).map((_, i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full"
              style={{
                backgroundColor: currentSlide === i ? "#8A8A8A" : "#D9D9D9",
              }}
            />
          ))}
      </div>
    </div>
  );
}
